import { render, staticRenderFns } from "./JournalFolderSelect.vue?vue&type=template&id=228344ac"
import script from "./JournalFolderSelect.vue?vue&type=script&lang=ts"
export * from "./JournalFolderSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports